import firebase from "firebase/app";
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"

// firebase init - add your own config here
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBNoae4li0GqeS9LauUWAh6MT3RlzD-e-o",
    authDomain: "aavinfedrecruitment-a425e.firebaseapp.com",
    databaseURL: "https://aavinfedrecruitment-a425e.firebaseio.com",
    projectId: "aavinfedrecruitment-a425e",
    storageBucket: "aavinfedrecruitment-a425e.appspot.com",
    messagingSenderId: "721571536021",
    appId: "1:721571536021:web:5212127800af4c3b7ccf9c",
    measurementId: "G-0JKNHMFXX7"
};
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()
const time = firebase.firestore.FieldValue;

// collection references
const usersCollection = db.collection('users')
const applicationsCollection = db.collection('applications')
const departmentsCollection = db.collection('departments')

// export utils/refs
export {
    db,
    auth,
    storage,
    usersCollection,
    applicationsCollection,
    departmentsCollection,
    time,
    firebase
}